import { css } from 'styled-components';

import { designColor, styledTypography } from '@pkg/primitives';

export const PLACEHOLDER = 'Username…';
export const UNIQUENESS_ERROR = 'That username is already taken.';

export const tokens = {
    padding: {
        // Unable to use `textBoxTrim` on a `<textarea />`
        // so we have to specify different padding values.
        top: 6,
        rest: 10,
    },
    minWidthCh: PLACEHOLDER.length,
    fontSize: 35,
    radius: 10,
};

export const baseWrapperStyles = css`
    display: inline-grid;
    justify-content: start;
    justify-items: start;
`;

export const baseTextStyles = css`
    ${styledTypography.allianceBase};
    padding-top: ${tokens.padding.top}px;
    padding-bottom: ${tokens.padding.rest}px;
    padding-left: ${tokens.padding.rest}px;
    padding-right: ${tokens.padding.rest}px;
    min-width: 100%;
    font-size: ${tokens.fontSize}px;
    font-weight: 700;
    line-height: 1.1;
    letter-spacing: -0.02em;

    @media (min-width: 768px) {
        min-width: ${tokens.minWidthCh}ch;
    }
`;

export const textElementStyles = css`
    ${baseTextStyles};
    ${styledTypography.breakTextarea};
    text-shadow:
        0px 0px 16px rgb(255, 255, 255, 0.8),
        0px 0px 22px ${designColor.brandPurple};
`;
